<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Administración de Agencias</h4>
          <hr class="horizontal dark" />
          <div class="d-flex justify-content-end">
            <a class="btn btn-addiuva-dark" @click="iniciarCrearAgencia()">
              <i class="fas fa-plus"></i> &nbsp; Crear Nueva Agencia
            </a>
          </div>
          <Toast />
          <DataTable :value="agencias" stripedRows paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay agencias que mostrar. </center></template>
            <Column field="nombre" header="Agencia" sortable ></Column>
            <Column field="departamento" header="Departamento" sortable ></Column>
            <Column field="direccion" header="Dirección" sortable ></Column>
            <Column field="telefono" header="Teléfono" sortable ></Column>
            <Column field="activado" header="Activo" sortable >
                <template #body="{ data }">
                    <Tag :value="(data.activado ? 'ACTIVO' : 'INACTIVO')" :severity="getSeverity(data.activado)" rounded/>
                </template>
            </Column>
            <Column field="company" header="Acción" style="width: 5%">
              <template #body="{ data }">
                <SplitButton label="Acciones" icon="fas fa-ellipsis-h" :model="data.items" menuButtonIcon="fas fa-ellipsis-h"  text v-if="data.items.length > 0" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <!-- Modal Dialogs -->
    <!-- Crear/Editar Usuario -->
    <Dialog v-model:visible="editar.visible" modal header="Header" :style="{ width: '40%' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
        <div class="inline-flex align-items-center justify-content-center gap-2">
          <h5 class="text-bold white-space-nowrap text-addiuva-dark" id="title-edit">{{editar.title.toUpperCase()}}</h5>
        </div>
      </template>
      <div class="row">
        <div class="col-md-8">
          <label for="nombre">Nombre Agencia <span class="text-danger">*</span></label>
          <InputText id="nombre" class="form-control" v-model="editar.nombre"/>
        </div>
        <div class="col-md-4">
          <label for="editar-activo">Activo</label>
          <div class="pt-1">
            <InputSwitch v-model="editar.activado" id="editar-activo"/>
          </div>
        </div>
        <div class="col-md-12">
          <label for="departamento">Departamento <span class="text-danger">*</span></label>
          <vue-select
            :options="departamentosOptions"
            label="text"
            v-model="editar.id_departamento"
            :reduce="(option) => option.value"
          ></vue-select>
        </div>
        <div class="col-md-12">
          <label for="direccion">Dirección</label>
          <InputText id="direccion" class="form-control" v-model="editar.direccion"/>
        </div>
        <div class="col-md-12">
          <label for="telefono">Teléfono</label>
          <InputText id="telefono" class="form-control" v-model="editar.telefono"/>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModal()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <button class="btn btn-addiuva-dark" @click="editAgency" v-if="editar.id">
          <i class="fas fa-pen pr-1"></i> Editar
        </button>
        <button class="btn btn-addiuva-dark" @click="createAgency" v-if="!editar.id">
          <i class="fas fa-save pr-1"></i> Guardar
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
import axios from 'axios';
import authHeader from '../services/auth-header';
// import moment from "moment"
export default {
  name: "Administración de Agencias",
  components: {
    VueSelect,
    DataTable,
    Column,
    Tag,
    Toast,
    SplitButton,
    Dialog,
    InputText,
    InputSwitch
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      showProfileDropdown: false,
      agencias: [],
      editar: {
        visible: false,
        title: null,
        id: null,
        nombre: null,
        id_departamento: null,
        departamento: null,
        direccion: null,
        telefono: null,
        activado: null,
      },
      departamentosOptions: [],
    };
  },
  methods: {
    listAgencies() {
      this.agencias = [];
      // Send Data by Axios
      let url = this.API_URL + "/agencias/lista";
      axios({
        url: url,
        method: 'post',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let agencias = [];
            data.forEach(a => {
              agencias.push({
                id: a.id_agencia ?? '',
                nombre: a.nombre ?? '',
                id_departamento: a.id_departamento ?? '',
                departamento: a.departamento ?? '',
                direccion: a.direccion ?? '',
                telefono: a.telefono ?? '',
                activado: a.activado ?? '',
              });
            });
            agencias.forEach(agencia => {
              agencia.items = this.defineSubMenu(agencia);
            });
            this.agencias = agencias;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getDepartamentos() {
      this.departamentosOptions = [];
      // Send Data by Axios
      let url = this.API_URL + "/agencias/lista/departamentos";
      axios({
        url: url,
        method: 'get',
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let roles = [];
            response.data.data.forEach(element => {
              roles.push({ text: element.nombre, value: element.id_departamento });
            });
            this.departamentosOptions = roles
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    defineSubMenu(data) {
      let items = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        }
      ];
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == true) severity = "success";
      if (status == false) severity = "danger";
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        title: 'Editar Agencia',
        id: data.id,
        nombre: data.nombre,
        id_departamento: data.id_departamento,
        departamento: data.departamento,
        direccion: data.direccion,
        telefono: data.telefono,
        activado: data.activado,
      };
      this.getDepartamentos();
    },
    closeModal() {
      this.editar = {
        visible: false,
        title: null,
        id: null,
        nombre: null,
        id_departamento: null,
        departamento: null,
        direccion: null,
        telefono: null,
        activado: null,
      };
    },
    editAgency() {
      if (this.editar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "nombre": this.editar.nombre,
        "id_departamento": this.editar.id_departamento,
        "direccion": this.editar.direccion,
        "telefono": this.editar.telefono,
        "activado": this.editar.activado,
      }
      // Send Data by Axios
      let url = this.API_URL + "/agencias/" + this.editar.id;
      axios({
        url: url,
        method: 'put',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Edición fue procesada exitosamente', life: 3000 });
            this.closeModal();
            this.listAgencies();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    createAgency() {
      if (this.editar.id != null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error.', life: 3000 });
        return true;
      }
      let payload = {
        "nombre": this.editar.nombre,
        "id_departamento": this.editar.id_departamento,
        "direccion": this.editar.direccion,
        "telefono": this.editar.telefono,
        "activado": this.editar.activado,
      }
      // Send Data by Axios
      let url = this.API_URL + "/agencias";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La agencia fue creado exitosamente', life: 3000 });
            this.closeModal();
            this.listAgencies();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Restauración
    iniciarCrearAgencia() {
      this.getDepartamentos();
      this.editar = {
        visible: true,
        title: 'Crear Agencia',
        id: null,
        nombre: null,
        id_departamento: null,
        departamento: null,
        direccion: null,
        telefono: null,
        activado: true,
      }
    },
    formatDate: function (date) {
      let aDate = date.split('/');
      return new Date(aDate[2], parseInt(aDate[1])-1, aDate[0]);
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Dashboard'});
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
    this.listAgencies()
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>